export default "__VITE_ASSET__6aR8AhYQ8J_mec4trO$H8g__"